import styled, { css } from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

interface DealersBandStyleProps {
  hidden?: boolean;
}

export const DealersBandBar = styled.div`
  width: 100%;
  font-family: 'Audi Type';
  line-height: 18px;
  color: ${COLORS.white};
  background: ${COLORS.black};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  ${({ hidden }: DealersBandStyleProps) => {
    if (hidden)
      return css`
        visibility: hidden;
        height: 0;
      `;
    return '';
  }};
`;

export const Section = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${SIZING.unit(2)} ${SIZING.unit(3.5)};
  border-bottom: 1px solid ${COLORS.white};
  @media ${device.tablet} {
    padding: ${SIZING.unit(2)} ${SIZING.unit(5)};
  }
  @media ${device.laptop} {
    padding: ${SIZING.unit(2)} ${SIZING.unit(11)};
  }
`;

export const Title = styled.p`
  font-size: 13px;
  color: ${COLORS.grey30};
  margin-left: ${SIZING.unit(0.5)};
  margin-right: ${SIZING.unit(0.5)};
  @media ${device.tablet} {
    font-size: 16px;
  }
`;

export const Button = styled.button`
  border: none;
  background: transparent;
  color: ${COLORS.whisper};
  font-family: 'Audi Type';
  font-weight: bold;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
  @media ${device.tablet} {
    font-size: 16px;
  }
`;
